import { render } from "./ServiceCategoryDatatableFormParentId.vue?vue&type=template&id=3c20c9bf"
import script from "./ServiceCategoryDatatableFormParentId.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryDatatableFormParentId.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__